module.exports = __webpack_public_path__ + "img/16bf81f.jpg";